import script from "./ActionDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ActionDialog.vue?vue&type=style&index=0&id=190f61e2&scoped=true&lang=css"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-190f61e2"]])

export default __exports__